export * from './additionalflat.model';
export * from './additionalflat-popup.service';
export * from './additionalflat.service';
export * from './additionalflat-dialog.component';
export * from './additionalflat-delete-dialog.component';
export * from './additionalflat-detail.component';
export * from './additionalflat.component';
export * from './additionalflat.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/index.ts